export const types = {
    login: 'login',
    register: 'registro',
    logout: 'logout',
}

